import { ALL_TAG, ResolvedTag } from '../data/gallery';
import { useLanguage } from '../contexts/LanguageContext';
import { translate } from '../i18n';

type Props = {
  activeTags: string[];
  availableTags: ResolvedTag[];
  onToggle: (tag: string) => void;
};

const TagFilter = ({ activeTags, availableTags, onToggle }: Props) => {
  const { locale } = useLanguage();

  const tags = availableTags;

  return (
    <section className="tag-filter" aria-labelledby="tag-filter-heading">
      <div className="tag-filter__header">
        <h2 id="tag-filter-heading">{translate(locale, 'filterLabel')}</h2>
      </div>
      <div className="tag-filter__list" role="list">
        {[ALL_TAG, ...tags.map((tag) => tag.id)].map((tagId) => {
          const isActive = activeTags.includes(tagId);
          const label =
            tagId === ALL_TAG
              ? translate(locale, 'allTag')
              : tags.find((tag) => tag.id === tagId)?.label[locale] ?? tagId;
          return (
            <button
              key={tagId}
              type="button"
              className={`tag-chip${isActive ? ' tag-chip--active' : ''}`}
              aria-pressed={isActive}
              onClick={() => onToggle(tagId)}
            >
              {label}
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default TagFilter;
